<template>
	<div style="display: inline-block;">
		<Input type="text" v-model="scanCodeId" placeholder="使用扫码枪或手动输入" @keydown.enter.native="scanDownFunc"
			@keyup.enter.native="scanUpFunc" icon="md-qr-scanner" style="width:200px;" />
		<!-- 使用封装的自定义抽屉组件 -->
		<CustomDrawer v-model="selectedSKU" :title="`选择单品`" :width="700" placement="right" :mask="true"
			:mask-closable="true" :closable="true">
			<template #title>
				<div class="drawer-title">
					<div class="drawer-title-left">
						<Icon type="ios-search" :size='18' />
						选择单品
					</div>
					<div class="drawer-title-right"></div>
				</div>
			</template>
			<div class="drawer-content">
				<Table :key="tableKey" :height='pageHeight' disabled-hover :columns="skuColumn"
					:data="formatData" @on-select="listSelected" @on-select-cancel='listSelectedCanel' @on-select-all='listSelectAll'
						@on-select-all-cancel='listSelectAllCanel'>
				</Table>
			</div>
			<template #footer>
				<div class="selected-sku">
					<Icon type="md-cart" size='20' />
					<span>已选:&nbsp;{{commoditySelected.length}}种️</span>
				</div>
				<button class="jxyd-button" @click="selectedSKU = false" style="margin-right: 10px;">取消</button>
				<button class="jxyd-button jxyd-primary" type="primary" @click="saveSelectedSKU">确定</button>
			</template>
		</CustomDrawer>
		<!-- 使用封装的图片预览子组件 -->
		<ImagePreview ref="imagePreview" :images="previewImagesList" :visible.sync="previewVisible"
			:initial-index="currentImageIndex" @change="onPreviewImageChange" />
	</div>
</template>

<script>
	import request from '@/utils/request'
	import ImagePreview from '@/components/ImagePreview' // 导入图片预览子组件
	import CustomDrawer from '@/components/CustomDrawer' // 导入自定义抽屉组件
	import formatNum from '@/utils/formatNum'
	export default {
		components: {
			ImagePreview,
			CustomDrawer
		},
		props: {
			commoditySelected: {
				type: Array,
				default: () => []
			},
			selectedBeforeCheck:{
				type:String,
				default:() =>''
			}
		},
		created: function() {
			this.$nextTick(() => {
				let contentElement = document.querySelector(".main-content");
				this.pageHeight = contentElement ? contentElement.offsetHeight - 120 : 700;
			})
		},
		computed: {},
		data() {
			return {
				formatData: [],
				tableKey: 0,
				scanCodeId: '',
				enterDownTime: '',
				enterUpTime: '',
				skuColumn: [{
						type: 'selection',
						width: 60,
						align: 'center',
						fixed: 'left'
					}, {
						title: '商品图片',
						key: 'imgs',
						width: 100,
						render: (h, params) => {
							return [h('div', {
								style: {
									'width': '40px',
									'height': '40px',
									'cursor': 'pointer'
								},
								on: {
									click: (val) => {
										this.previewSkuImages(params.row.commodityPriceTypeGroup
											.imgFiles && params.row.commodityPriceTypeGroup
											.imgFiles.length > 0 ? params.row
											.commodityPriceTypeGroup.imgFiles : params.row
											.commodityPriceTypeGroup.commodity.imgFile);
									}
								}
							}, [h('Avatar', {
								style: {
									'width': '100%',
									'height': '100%',
								},
								attrs: {
									'src': this.getImgList(params.row),
								}
							})])];
						}
					},
					{
						title: '商品',
						key: 'name',
						width: 220,
						render: (h, params) => {
							return h('a', {
								class: 'jxyd-a',
								on: {
									click: (e) => {
										this.$router.push({
											path: 'commoditydetailinfo',
											query: {
												commodityId: params.row.commodityPriceTypeGroup
													.commodity.id
											}
										});
									}
								}
							}, params.row.commodityPriceTypeGroup.commodity.name);
						}
					},
					{
						title: '规格',
						key: 'priceType',
						width: 220,
					},
					{
						title: '当前库存',
						key: 'stock',
						width: 100,
						render: (h, params) => {
							return h('span', {}, this.getCurrentIStock(params.row) + params.row
								.commodityPriceTypeGroup.commodity.unit);
						}
					},
					{
						title: '采购价',
						key: 'intoPrice',
						width: 100,
						render: (h, params) => {
							return h('span', {}, params.row.intoPrice + '元');
						}
					},
					{
						title: '零售价',
						key: 'retailPrice',
						width: 100,
						render: (h, params) => {
							return h('span', {}, params.row.retailPrice + '元');
						}
					},
					{
						title: '批发价',
						width: 100,
						key: 'wholesalePricePrice',
						render: (h, params) => {
							return h('span', {}, params.row.wholesalePricePrice + '元');
						}
					}
				],
				selectedSKU: false,
				// 图片预览相关 - 简化后的变量
				previewVisible: false,
				previewImagesList: [],
				currentImageIndex: 0,
				pageHeight: 0,
				searchItems: {
					name: '',
					code: '',
					format: '',
					isUse: -1,
					depotId: 0,
					note: '',
					type: [],
					sort: '',
					pageSize: 10,
					pageIndex: 1
				}
			}
		},
		methods: {
			saveSelectedSKU() {
				this.$emit('submitSelected', this.commoditySelected);
				this.selectedSKU = false;
			},
			scanDownFunc() {
				this.enterDownTime = new Date().getTime();
			},
			async scanUpFunc() {
				if(this.selectedBeforeCheck){
					this.$Notice.error({
						title: '错误提示',
						duration: 3,
						desc: this.selectedBeforeCheck
					});
					return;	
				}
				this.enterUpTime = new Date().getTime();
				if (this.enterUpTime - this.enterDownTime < 30) {
					await this.selectCommodityByScanCode(this.scanCodeId);
				 	this.scanCodeId = '';
				 } else {
				 	this.$emit('onInputVal', this.scanCodeId);
					this.$refs.selectCommodityModal.searchItems.searchVal = this.scanCodeId;
					this.$refs.selectCommodityModal.openSelectCommodityModal();
					this.scanCodeId = '';
				}
			},
			getImgList(data) {
				if (data.commodityPriceTypeGroup.imgFiles && data.commodityPriceTypeGroup.imgFiles.length > 0) {
					return data.commodityPriceTypeGroup.imgFiles[0].url;
				}
				if (data.commodityPriceTypeGroup.commodity.imgFile && data.commodityPriceTypeGroup.commodity.imgFile
					.length > 0) {
					return data.commodityPriceTypeGroup.commodity.imgFile[0].url;
				}
				return '/file/file/GetFile?fileName=DefaultCommodity.png&path=/app/Uploads/FIXIMG/DefaultCommodity.png';
			},
			async selectCommodityByScanCode(code) {
				try {
					this.searchItems.name = code;
					let result = await request.post('/api/Commodity/GetCommodityFormatList2', this.searchItems);
					if (result.state !== 1 || !result.data.commodity || result.data.commodity.length < 1) {
						result = await request.post('/api/Commodity/GetCommodityFormatList2', this.searchItems);
						if (result.state !== 1 || !result.data.commodity || result.data.commodity.length < 1) {
							this.showError('未找到商品或规格');
							return
						}
						result.data.commodity.forEach(item=>{
							var data = this.commoditySelected.find(m => m.id == item.id);
							if (!data) {
								this.commoditySelected.push(item);
							}
						})
						this.$emit('submitSelected', this.commoditySelected);
						return
					}
					if(result.data.length == 1){
						var data = this.commoditySelected.find(m => m.id == result.data[0].id);
						if (!data) {
							this.commoditySelected.push(result.data[0]);
						}
						this.$emit('submitSelected', this.commoditySelected);
						return
					}
					this.formatData = result.data.commodity;
					this.tableKey += 1;
					this.initSelectedRow();
					this.selectedSKU = true;
				} catch (error) {
					this.showError('请重新扫描')
				}
			},
			showError(message) {
				this.$Notice.error({
					title: '错误提示',
					duration: 3,
					desc: message
				});
			},
			/**
			 * 预览SKU图片 - 简化版本，使用子组件
			 */
			previewSkuImages(images) {
				if (!images || images.length === 0) {
					this.$Notice.error({
						title: '错误提示',
						duration: 3,
						desc: "暂无图片"
					});
					return;
				}

				this.previewImagesList = images;
				this.currentImageIndex = 0;
				this.previewVisible = true;
			},
			/**
			 * 图片切换事件
			 */
			onPreviewImageChange(index, image) {
				this.currentImageIndex = index;
			},
			getCurrentIStock(data) {
				let commodityInventorys = data.commodityPriceTypeGroup.commodity
					.commodityInventorys;
				if (!commodityInventorys) {
					return 0;
				}
				let stock = 0;
				for (let i = 0; i < commodityInventorys.length; i++) {
					if (commodityInventorys[i].commodityPriceType == data.commodityPriceTypeGroup.groupName + ',' + data
						.priceType) {
						stock += commodityInventorys[i].stock;
					}
				}
				return formatNum(stock);
			},
			listSelected(items, row) {
				this.commoditySelected.push(row);
			},
			listSelectedCanel(items, row) {
				this.commoditySelected.forEach((item, index) => {
					if (row.id == item.id) {
						this.commoditySelected.splice(index, 1);
					}
				});
			},
			listSelectAll(items) {
				let isExist = false;
				for (let i = 0; i < items.length; i++) {
					isExist = false;
					for (let n = 0; n < this.commoditySelected.length; n++) {
						if (items[i].id === this.commoditySelected[n].id) {
							isExist = true;
							break;
						}
					}
					if (!isExist) {
						this.commoditySelected.push(items[i]);
					}
				}
			},
			listSelectAllCanel(items) {
				for (let i = 0; i < this.formatData.length; i++) {
					for (let n = 0; n < this.commoditySelected.length; n++) {
						if (this.formatData[i].id === this.commoditySelected[n].id) {
							this.commoditySelected.splice(n, 1);
							break;
						}
					}
				}
			},
			initSelectedRow() {
				this.formatData.forEach((item2, index2) => {
					if (item2.commodityPriceTypeGroup.commodity.isUse == false) {
						item2._disabled = true;
					}
					this.commoditySelected.forEach((item, index) => {
						if (item.id == item2.id) {
							item2._checked = true;
						}
					});
				});
			},
		}
	}
</script>

<style scoped>
	.modal-content {
		min-height: 500px;
	}

	#page-box {
		margin-top: 15px;
		text-align: center;
	}

	.selected-goods {
		float: left;
		height: 52px;
		line-height: 52px;
		text-align: center;
		width: auto;
		padding: 0px 10px;
		color: #fff;
		background-color: rgb(255, 106, 127);
		font-size: 15px;
		cursor: pointer;
		font-weight: bold;
		border-radius: 0px 0px 0px 6px;
	}

	/deep/ .ivu-modal-footer {
		padding: 0px !important;
		background-color: rgba(255, 255, 255, 0) !important;
	}

	.selected-sku {
		float: left;
		height: 32px;
		line-height: 32px;
		text-align: center;
		width: auto;
		padding: 0px 10px;
		color: rgb(255, 106, 127);
		font-size: 18px;
		cursor: pointer;
		font-weight: bold;
		border-radius: 0px 0px 0px 6px;
	}

	.footer-tool {
		padding: 10px;
	}

	/deep/ .ivu-badge-count {
		top: -3px;
	}

	/deep/ .ivu-modal-content {
		background-color: white;
	}

	/deep/ .ivu-modal-body {
		padding: 0px;
	}

	#box-search {
		margin-bottom: 15px;
		overflow: hidden;
	}

	.search_input {
		width: 200px;
		margin-right: 15px;
	}

	.box-search-left {
		float: left;
	}

	.box-search-right {
		float: right;
	}

	.modal-header {
		display: flex;
		justify-content: flex-start;
		align-items: center;
		overflow: hidden;
		color: rgb(255, 106, 127);
	}

	/* 抽屉内容区域样式 */
	.drawer-content {
		padding: 10px;
		height: 100%
	}

	.drawer-content-item {}

	.drawer-content-item+.drawer-content-item {
		border-top: 1px solid #e8e8e8;
		padding-top: 10px;
		margin-top: 10px;
	}

	.drawer-content-item /deep/ div {
		border: none !important;
	}

	.content-input {
		border: none;
		outline: none;
		height: 15px;
		padding-left: 0px;
		width: 100%;
		flex: 1;
		text-align: right;
		margin: 0px 15px;
	}
</style>